import { render } from "./ObjectiveSectionLayout.vue?vue&type=template&id=cb86380a&scoped=true"
import script from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js"
export * from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js"

import "./ObjectiveSectionLayout.vue?vue&type=style&index=0&id=cb86380a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb86380a"]])

export default __exports__